import { useSidebarStore } from 'common/layouts/main-layout/service/sidebar-service/service-store/service-store';
import { sidebarServiceIsOpenMenuSelector } from 'common/layouts/main-layout/service/sidebar-service/service-store/selectors';
import { useSidebarActions } from 'common/layouts/main-layout/service/sidebar-service/hooks';
export var ToggleOpenMenuButton = function (_a) {
    var children = _a.children;
    var toggleOpenMenu = useSidebarActions().toggleOpenMenu;
    var isOpen = useSidebarStore(sidebarServiceIsOpenMenuSelector);
    return children({ isActive: isOpen, onClick: toggleOpenMenu });
};
